(() => {
  const body = document.querySelector('[data-vp-article-body]');
  const toc = document.querySelector('.vp-article-toc');
  if (!body) return;
  body.querySelectorAll('table').forEach(table => {
    if (table.closest('.vp-article-table-scroll')) return;
    const parentOverflow = getComputedStyle(table.parentElement).overflowX;
    if (parentOverflow === 'auto' || parentOverflow === 'scroll') return;
    const region = document.createElement('div');
    region.className = 'vp-article-table-scroll';
    const caption = table.querySelector('caption');
    const precedingHeading = [...body.querySelectorAll('h2, h3')].filter(h => h.compareDocumentPosition(table) & Node.DOCUMENT_POSITION_FOLLOWING).pop();
    const label = [caption, precedingHeading, document.querySelector('h1')].map(el => el?.textContent.trim()).find(Boolean) || document.title;
    region.setAttribute('role', 'region');
    region.setAttribute('aria-label', label);
    table.before(region);
    region.append(table);
    region.addEventListener('keydown', event => {
      if (event.target !== region || region.scrollWidth <= region.clientWidth + 1) return;
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      if (event.key === 'Home') region.scrollLeft = 0;
      else if (event.key === 'End') region.scrollLeft = region.scrollWidth;
      else region.scrollLeft += event.key === 'ArrowRight' ? 40 : -40;
    });
    const updateFocus = () => {
      if (region.scrollWidth > region.clientWidth + 1) region.tabIndex = 0;
      else region.removeAttribute('tabindex');
    };
    updateFocus();
    if ('ResizeObserver' in window) {
      const observer = new ResizeObserver(updateFocus);
      observer.observe(region);
      observer.observe(table);
    }
  });
  if (!toc || body.querySelectorAll('a[href^="#"]').length >= 3) return;
  const headings = [...body.querySelectorAll('h2')].filter(h => h.textContent.trim());
  if (headings.length < 3) return;
  const list = toc.querySelector('ol');
  headings.forEach((heading, index) => {
    heading.tabIndex = -1;
    if (!heading.id) {
      let id = `vp-article-section-${index + 1}`;
      while (document.getElementById(id)) id += '-next';
      heading.id = id;
    }
    const item = document.createElement('li');
    const link = document.createElement('a');
    link.href = `#${encodeURIComponent(heading.id)}`;
    link.textContent = heading.textContent.trim();
    item.append(link);
    list.append(item);
  });
  toc.hidden = false;
})();
